import { atom, selectorFamily } from 'recoil';
import { PrivilegeService } from 'api';
export const getPrivilegesRequestId = atom({
  key: 'getPrivilegesRequestId',
  default: 0
});
export const customerPrivilegesPagination = atom({
  key: 'customerPrivilegesPagination',
  default: {
    max: 10,
    offset: 0
  }
});
export const searchCustomerPrivileges = selectorFamily({
  key: 'getCustomerPrivileges',
  get: customerId => async ({
    get
  }) => {
    get(getPrivilegesRequestId);
    if (!customerId) return null;
    const pagination = get(customerPrivilegesPagination);
    try {
      const privileges = await PrivilegeService.searchPrivileges({
        customerId,
        body: {
          ...pagination
        }
      });
      return privileges;
    } catch (error) {
      console.error('Could not fetch pending privileges for the customer', error);
      return null;
    }
  }
});